import React, { useEffect, useState } from 'react'
import ModalTest from '../../../BaseModal'
import * as S from '../../../styles/modal-style'
import { X } from 'lucide-react'
import SelectAndSearch from '../../../SelectAndSearch'
import axios from '../../../../config/axios'
import InputFiles from '../../../ui/InputFiles'
import LoadImages from '../../../ui/LoadImages'

interface AddServiceModalProps {
  id: number
  setModalActive: React.Dispatch<React.SetStateAction<number | null>>
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  serviceToEdit?: any
  setServiceToEdit: React.Dispatch<React.SetStateAction<any>>
}

export interface ServiceToAddType {
  id?: number
  stageId: number
  name: string
  image: File | null
  description: string
  observation: string
}

const AddServiceModal = ({ setModalActive, id, setRefresh, serviceToEdit, setServiceToEdit }: AddServiceModalProps) => {
  const [services, setServices] = useState<Partial<ServiceToAddType>[]>([])
  const [formData, setFormData] = useState<ServiceToAddType>({
    stageId: 0,
    name: '',
    description: '',
    image: null,
    observation: ''
  })
  const [inactiveButton, setInactiveButton] = useState<boolean>(false)

  useEffect(() => {
    if (formData.description !== '' && formData.observation !== '' && formData.stageId !== 0) {
      setInactiveButton(false)
    } else {
      setInactiveButton(true)
    }
  }, [formData])

  const handleSelectService = (service: Partial<ServiceToAddType>) => {
    setFormData(prev => ({
      ...prev,
      stageId: service.id || 0,
      name: service.name || '',
      description: service.description || '',
      observation: service.observation || '',
    }))
    setInactiveButton(true)
  }

  const handleChangeInfos = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
    setInactiveButton(true)
  }

  const handleAddImage = (file: File) => {
    setFormData(prev => ({
      ...prev,
      image: file
    }))
  }

  
  const handleAddService = async () => {
    if (inactiveButton) return
    try {
      setInactiveButton(true)
      const response = await axios.patch(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/oldpcp/update/${id}`, 
        {stages: [{...formData, index: 0}]}
      )
      if (response.data) {
        setServiceToEdit(null)
        setModalActive(null)
        setRefresh(prev => !prev)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setInactiveButton(false)
    }
  }

  const handleEditService = async () => {
    console.log({ stageId: formData.stageId, id: formData.id, description: formData.description, observation: formData.observation })
    if (inactiveButton) return
    try {
      setInactiveButton(true)
      console.log({ stageId: formData.stageId, id: formData.id, description: formData.description, observation: formData.observation })
      const response = await axios.patch(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/edit-stage/${id}`, { stageId: formData.stageId, id: formData.id, description: formData.description, observation: formData.observation });
      if (response.data) {
        setServiceToEdit(null)
        setModalActive(null)
        setRefresh(prev => !prev)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setInactiveButton(false)
    }
  }

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/stages`)
        if (response.data) setServices(response.data)
      } catch (error) {
        console.log(error)
      }
    }
    fetchServices()
  }, [])

  useEffect(() => {
    if (serviceToEdit) {
      setFormData({
        id: serviceToEdit.id,
        stageId: serviceToEdit.stageId,
        name: serviceToEdit.name,
        description: serviceToEdit.description,
        observation: serviceToEdit.observation,
        image: serviceToEdit.image
      })
    } else {
      setFormData({
        stageId: 0,
        name: '',
        description: '',
        image: null,
        observation: ''
      })
    }
  }, [serviceToEdit])

  return (
    <ModalTest>
      <S.ContainerOfModal width='42rem'>
        <S.Header>
          <S.HeaderTitle>{serviceToEdit ? 'Editar Serviço' : 'Adicionar Serviço'}</S.HeaderTitle>
          <S.CloseDiv onClick={() => {
            setServiceToEdit(null)
            setModalActive(null)
          }}> <X size={20} /></S.CloseDiv>
        </S.Header>
        <S.FormContainer>
          <SelectAndSearch label='Selecione o serviço' options={services} onSelect={handleSelectService} selectedOption={{ id: formData.stageId, name: formData.name }} />
          <S.InputDiv>
            <S.Label>Descrição detalhada</S.Label>
            <S.Textarea placeholder='Digite aqui' name='description' value={formData.description} onChange={handleChangeInfos} />
          </S.InputDiv>
          <S.InputDiv>
            <S.Label>Observações</S.Label>
            <S.Textarea placeholder='Digite aqui' name='observation' value={formData.observation} onChange={handleChangeInfos} />
          </S.InputDiv>
        </S.FormContainer>
        <S.BottomDiv>
          <S.ButtonContainer>
            <S.Button onClick={() => {
              setServiceToEdit(null)
              setModalActive(null)
            }} className='cancel'>Cancelar</S.Button>
            <S.Button onClick={serviceToEdit ? handleEditService : handleAddService} className={inactiveButton ? 'inactive' : ''}>{serviceToEdit ? 'Salvar Alterações' : 'Adicionar Serviço'}</S.Button>
          </S.ButtonContainer>
        </S.BottomDiv>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default AddServiceModal